/**
 * WD-2 — Unpublish confirm.
 * US-A02 AC5: the item disappears from the app while existing progress is kept.
 */
import { useAdminTranslate } from '@/providers/i18n-provider'
import { ConfirmDialog } from './ConfirmDialog'

export interface UnpublishConfirmDialogProps {
  open: boolean
  targetLabel: string
  onConfirm: () => Promise<void> | void
  onCancel: () => void
}

export const UnpublishConfirmDialog = ({
  open,
  targetLabel,
  onConfirm,
  onCancel,
}: UnpublishConfirmDialogProps) => {
  const translate = useAdminTranslate()

  return (
    <ConfirmDialog
      open={open}
      title={translate('admin.dialogs.unpublish.title', { target: targetLabel })}
      description={translate('admin.dialogs.unpublish.description')}
      confirmLabel={translate('admin.dialogs.unpublish.confirm')}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}
